import { BuiltinType } from './types';
export class BuiltinCall {
    constructor() {
        this.types = new Set([BuiltinType.Call]);
    }
}

//# sourceMappingURL=BuiltinCall.js.map
